import { render, staticRenderFns } from "./ShowDialogSliderEmpresas.vue?vue&type=template&id=1d542ff2&scoped=true"
import script from "./ShowDialogSliderEmpresas.vue?vue&type=script&lang=js"
export * from "./ShowDialogSliderEmpresas.vue?vue&type=script&lang=js"
import style0 from "./ShowDialogSliderEmpresas.vue?vue&type=style&index=0&id=1d542ff2&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d542ff2",
  null
  
)

export default component.exports